import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { clearReduxStore } from "containers/InitialStore";
import { AdminHeader } from "components";

import { getFormValues, isValid, reset } from "redux-form";

import * as commonVar from "libs/commonVar";

import * as adminActions from "modules/admin";
import * as userActions from "modules/user";
import * as loginActions from "modules/login";

import * as adminLib from "libs/adminLib";
import * as validFunc from "libs/validation";

class CtAdminHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModal: "",
      isClicked: false,
      errorMessage: { type: "", content: "" },
    };
    //this.handleGoService = this.handleGoService.bind(this);
  }

  // 비밀번호 변경 모달
  // 모달 처리
  onToggleModal = (viewType) => {
    const { ReduxFormReset } = this.props;
    ReduxFormReset("formEditPassword");

    this.setState({ isModal: viewType, errorMessage: { type: "", content: "" } });
  };

  // 비밀번호 변경
  onSaveEditPassword = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { formEditPassword, isValidFormEditPassword } = this.props;

    if (!formEditPassword || 
      (formEditPassword && (!formEditPassword.newPassword || !formEditPassword.newPasswordAgain))) return;

    if (formEditPassword.newPassword === formEditPassword.newPasswordAgain) {
      this.setState({
        errorMessage: { type: "", content: "" },
      });

      if (isValidFormEditPassword) {
        this.setState({ isClicked: true });

        const param = {
          beforePasswd: formEditPassword.beforePassword,
          newPasswd: formEditPassword.newPassword,
        };

        try {
          const respObj = await adminLib.editPassword(param);
          if (respObj && respObj.status && respObj.status === 200) {
            if (respObj.data && Array.isArray(respObj.data.list)) {
              // 비밀번호 변경 성공
              this.setState({
                errorMessage: {
                  type: "success",
                  content: defineMessages(formatMessage({ id: "CtUser_2", defaultMessage: "비밀번호가 변경 되었습니다." })),
                },
              });
            } else {
              if (Array.isArray(respObj.data.error)) {
                this.setState({
                  errorMessage: {
                    type: "beforePassword",
                    content: respObj.data.error[0].errInfo,
                  },
                });
              } else {
                // 비밀번호 틀림
                this.setState({
                  errorMessage: {
                    type: "beforePassword",
                    content: defineMessages(formatMessage({ id: "CtUser_3", defaultMessage: "비밀번호가 틀렸습니다." })),
                  },
                });
              }
            }
          } else {
            // 응답 오류
          }

          this.setState({ isClicked: false });
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      this.setState({
        errorMessage: {
          type: "newPasswordAgain",
          content: defineMessages(formatMessage({ id: "CtUser_4", defaultMessage: "비밀번호가 일치 하지 않습니다" })),
        },
      });
      this.setState({ isClicked: false });
    }
  };

  handleGoService = () => {
    if (commonVar.isGs !== 1) {
      this.props.history.push("/intro");
    } else {
      this.props.history.push("/login");
    }
  };

  // 로그 아웃
  handleLogout = () => {
    const { UserActions, LoginActions } = this.props;

    localStorage.removeItem("loginAdmin");
    localStorage.removeItem("loginUser");
    sessionStorage.removeItem("curUser");
    // 로그아웃 처리
    UserActions.logout();
    // 로그인 초기화
    LoginActions.setInitial();
  };

  handleToggleAdminMenu = () => {
    const { AdminActions } = this.props;

    AdminActions.toggleMenuVisible();
  };

  render() {
    const { isAuth, menuOpen } = this.props;
    const { handleGoService, handleLogout, handleToggleAdminMenu, onSaveEditPassword, onToggleModal } = this;

    return (
      <AdminHeader
        isAuth={isAuth}
        isModal={this.state.isModal}
        isClicked={this.state.isClicked}
        menuOpen={menuOpen}
        onToggleAdminMenu={handleToggleAdminMenu}
        onLogout={handleLogout}
        handleGoService={handleGoService}
        editPasswordData={{
          errorMessage: this.state.errorMessage,
          onSaveEditPassword: onSaveEditPassword,
          onToggleModal: onToggleModal,
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.user.get("isAuth"),
  menuOpen: state.admin.get("menuOpen"),
  formEditPassword: getFormValues("formEditPassword")(state),
  isValidFormEditPassword: isValid("formEditPassword")(state),
});

const mapDispatchToProps = (dispatch) => ({
  UserActions: bindActionCreators(userActions, dispatch),
  AdminActions: bindActionCreators(adminActions, dispatch),
  LoginActions: bindActionCreators(loginActions, dispatch),
  Dispatch: dispatch,
  ReduxFormReset: bindActionCreators(reset, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminHeader)));



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminHeader.js